<!--基础信息-->
<template>
  <div >
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

    <a-card class="all-card-style " >

      <a-form-model  :rules="FormRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" :model="EntInfo" ref="EntInfo">

        <a-row>
          <a-col :span="8">
            <a-form-model-item prop="cEntCode" label="企业编码"  class="ant-form-item2 " >
              <a-input v-model="EntInfo.cEntCode" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col span="8">
            <a-form-model-item prop="cEntName" label="企业名称"  class="ant-form-item2 " >
              <a-input v-model="EntInfo.cEntName" placeholder="请输入" />
            </a-form-model-item>
          </a-col>

          <a-col span="8">
            <a-form-model-item prop="cEntNature" label="企业性质"  class="ant-form-item2 " >
              <a-select v-model="EntInfo.cEntNature" class="ant-form-item3 "   >
                <a-select-option value="私企">
                  私企
                </a-select-option>
                <a-select-option value="国企">
                  国企
                </a-select-option>
                <a-select-option value="民企">
                  民企
                </a-select-option>
              </a-select>

            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item prop="cChargeUser" label="负责人"  class="ant-form-item2 " >
              <a-input v-model="EntInfo.cChargeUser" placeholder="请输入" />
            </a-form-model-item>
          </a-col>



          <a-col :span="8">
            <a-form-model-item label="成立日期"  class="ant-form-item2 " >
              <a-date-picker placeholder="请选择日期" v-model="EntInfo.dEstblDate"  />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item label="负责人手机"  class="ant-form-item2 " >
              <a-input v-model="EntInfo.cChargeMoblie" placeholder="请输入" />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item label="电话"  class="ant-form-item2 " >
              <a-input v-model="EntInfo.cEntPhone" placeholder="请输入" />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item label="邮箱"  class="ant-form-item2 " >
              <a-input v-model="EntInfo.cEntEmail" placeholder="请输入" />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item label="传真"  class="ant-form-item2 " >
              <a-input v-model="EntInfo.cEntFax" placeholder="请输入" />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item label="省/市/区"  class="ant-form-item2 " >
<!--              <a-input v-model="EntInfo.cEntCountry" placeholder="请输入" />-->
              <a-cascader :options="options" v-model="dfi" placeholder="请选择" @change="onChange"   class="ant-form-item2 " />
            </a-form-model-item>
          </a-col>

<!--          <a-col :span="8">-->
<!--            <a-form-model-item label="市">-->
<!--              <a-input v-model="EntInfo.cEntCity" placeholder="请输入" />-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->

<!--          <a-col :span="8">-->
<!--            <a-form-model-item label="区">-->
<!--              <a-input v-model="EntInfo.cEntArea" placeholder="请输入" />-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->

<!--          <a-col :span="8">-->
<!--            <a-form-model-item label="镇/村">-->
<!--              <a-input v-model="EntInfo.cEntVillage" placeholder="请输入" />-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->

          <a-col :span="8">
            <a-form-model-item label="详细地址"  class="ant-form-item2 " >
              <a-input v-model="EntInfo.cEntAddress" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="企业介绍"  class="ant-form-item2 " >
              <a-textarea
                v-model="EntInfo.cProduce" placeholder="请输入" style="color:#ffffff;"
                :auto-size="{ minRows: 5, maxRows: 16 }"
              />

            </a-form-model-item>
          </a-col>
        </a-row>





        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" @click="SaveForms" html-type="button">
            修改
          </a-button>
        </a-form-model-item>

      </a-form-model>

    </a-card>


  </div>
</template>

<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'
  import { _getEntPlatFormData } from '@/common/request'

  export default {
    name: 'basicInformationList',
    components: {
      TitleCard
    },
    data() {
      return {
        titleMsg1: "系统管理",
        titleMsg2:'基础信息',
        titleMsg3:'基础信息',
        EntInfo:{},
        dfi:['110000','110100','110101'],
        FormRules:{

          cEntCode:
            [
              { required: true, message: '请输入企业编码', trigger: 'blur' }
            ],
          cEntName: [
            { required: true, message: '请输入企业名称', trigger: 'blur' }
          ],
          cEntNature:[
            { required: true, message: '请选择企业性质', trigger: 'change' }
          ],
          dEstblDate:[
            { required: true, message: '请选择成立日期', trigger: 'blur' }
          ],
          cChargeUser:[
            { required: true, message: '请输入负责人', trigger: 'blur' }
          ]

        },

        options:[]

      }
    },
    mounted () {
      this.EntInfo.ID=this.$store.getters.User.enterprise.ID;
      this.HandleDetail();
    },
    methods:{
      toAddPage(){
        // this.$router.push({path:'/equipment/equipmentDetails'});

      },
     async HandleDetail(){
        /*获取项目列表*/

          var that=this
       let resArea=await  that.$http.post("/Enterprise/GetAreaJSON",{});
     //     console.log('resarea',resArea.data.obj) ;
          that.options=eval(resArea.data.obj);
          let res=await that.$http.post('/Enterprise/FindById2?id='+that.EntInfo.ID,{})


          if(res.data.code=="200"){
            that.EntInfo=res.data.obj.data;
console.log('    that.EntInfo',    that.EntInfo);
            that.dfi=[ that.EntInfo.cEntCountry+'', that.EntInfo.cEntCity+'', that.EntInfo.cEntArea+''];

            console.log('     that.dfi',     that.dfi);
          }


      },
      onChange(_value){
        console.log('_value',_value);
        this.EntInfo    .cEntCountry= _value[0];
        this.EntInfo    .cEntCity=  _value[1];
        this.EntInfo    .cEntArea=  _value[2];
      },
      //保存权限
      async SaveForms () {
        let that = this;

        that.$refs['EntInfo'].validate(async valid => {

          if (valid) {


            let res = await that.$http.post('Enterprise/Save2', that.EntInfo)


            if (res.data.code == "200") {
              that.$message.success('保存成功!')

            } else {
              that.$message.error(res.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>

<style>
  .emal-table-box{
    margin-top: 32px;
  }
  .ant-cascader-menus{
    color:#000000;
  }
</style>
